module.exports = __webpack_public_path__ + "static/img/2_10commitments_80percent.7e64a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/2_10commitments_80percent.jpg
// module id = PMX1
// module chunks = 0